<template>
	<div>
		<TableList  :form_data_seo.sync="form_data_seo" :columns="columns" :get_table_list="this.get_table_list"
			:slot_table_list="['operation']" ref="list">
			<template slot="operation" slot-scope="data">
				<span>
					<a @click="see(data.record)">查看</a>
					<a-divider type="vertical" v-auth="'delete'" />
					<a  v-auth="'delete'" @click="getDelete(data.record)">删除</a>
				</span>
			</template>
		</TableList>
	</div>
</template>

<script>
	import TableList from '@/components/TableList'
	import {
		message,
		Modal
	} from 'ant-design-vue';
	import {
		getQualityRecordList,
		getFactorySelect,getTemplateType,deleteQualityRecord
	} from '@/api/quality'
	const columns = [{
			title: "Id",
			dataIndex: "id",
		},
		{
			title: "名称",
			dataIndex: "title",
			width: 400,
		},
		{
			title: "类型",
			dataIndex: "template_title",
			
		},
		{
			title: "填写人员",
			dataIndex: "username",
		},
		{
			title: "填写时间",
			dataIndex: "inspection_time",
		},
		{
			title: "提交时间",
			dataIndex: "submit_time",
		},

		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			}
		},
	];

	export default {
		name: "excelList",
		components: {
			TableList,Modal
		},
		data() {
			return {
				get_table_list: getQualityRecordList,
				columns,
				form_data_seo: {
					list: [

						{
							type: "text",
							name: "keyword",
							title: "名称",
							placeholder: '请输入',
							options: {

							}
						},

						{
							 type: "tree-select",
							name: "template_id",
							title: "类型",
							options: {},
							treeData: [],
							replaceFields: {
							    label: "name",
							    value: "id",
							    children: "sub"
							},
						},
						{
							type: "text",
							name: "user_keyword",
							title: "人员",
							placeholder: '姓名/账号/工号/手机号',
							options: {

							}
						},
						{
							type: "select",
							name: "factory_id",
							title: "所属工厂",
							options: {},
							list: [],
						},
						{
							type: "range_date",
							name: "range_date",
							title: "提交时间",
							options: {},
							start: {
								name: "submit_start"
							},
							end: {
								name: "submit_end"
							},
						},
						{
							type: "range_date",
							name: "range_dat22e",
							title: "填写时间",
							options: {},
							start: {
								name: "inspection_start"
							},
							end: {
								name: "inspection_end"
							},
						}

					],
					...this.$config.form_data_seo
				},

			}
		},
		created() {
			
			this.getFactorySelect()
		},
		methods: {
			getFactorySelect() {
				getTemplateType().then(res=>{
					console.log( res.data.list)
					this.form_data_seo.list[1].treeData = res.data.list
				})
				getFactorySelect({
					data: {
						"type": "search" //类型 search搜索 other其它
					}
				}).then(res => {
					this.form_data_seo.list[3].list = res.data.list.map(item=>{
						return {
							key:item.value,
							value:item.label,
						}
					})
					
				})
			},
			getDelete(info) {
				console.log(info)
				let that = this
				Modal.confirm({
					title: '温馨提示',
					content: '确定要删除品项【' + info.title + '】吗？',
					okText: '确定',
					cancelText: '取消',
					onOk() {
						deleteQualityRecord({
							data:{
								id: info.id
							}
						}).then(res => {
							message.success('删除成功');
							that.$refs.list.get_list()
						})
					}
				});
			},
			see(e) {
				this.$keep_route.add(this.$options.name);
				let examine = this.$store.state.page_auth.examine
				this.$router.push({
					path: '/control/form/info',
					query: {
						id: e.id,
						type: 2,
						p_type:e.type,
						examine:examine
					}
				})

			},


		}
	}
</script>
<style type="text/css" scoped>
	.slot_test {
		display: flex;
	}

	.barnd_name {
		flex: 2;
	}

	.barnd_rt {
		flex: 1;
		margin-left: 10px;
	}

	.brand_value_list {
		display: flex;
		width: 100%;
	}

	.brand_value_input {
		flex: 1;
	}

	.brand_value_icon {
		width: 50px;
		margin-left: 10px;
	}
</style>